import React, { Component } from 'react';
import {Button } from 'antd';

class passwordUpdated extends Component {	

	render() {
		return (			
			<div className="exterior-container">
				<div className="inner-exterior-container" style={{justifyContent: 'space-around'}}>
					<div className="info-container" style={{maxWidth: '365px'}}>
						<img src="./img/logo-efisco.png" alt="efisco" style={{marginBottom: '20px'}} />
						<h2 className="blue-text register-title title-text" style={{marginBottom: '10px'}}>
							Tu nueva contraseña se ha guardado exitosamente
						</h2>
						<p className="label">
							Ya puedes iniciar sesión con tu nueva contraseña
						</p>
						<Button type="primary" onClick={()=> {this.props.history.push('/');}}>
							Ir a inicio de sesión
						</Button>
					</div>
				</div>
			</div>
		)
	}
}

export default (passwordUpdated);